import { fetchNotes } from '../services/patientNotes';
import { PATIENT_NOTES_KEY } from './queryKeys';

export function patientNotesQuery(patientId: string) {
    return {
        queryKey: PATIENT_NOTES_KEY(patientId),
        queryFn: () => fetchNotes(patientId, true)
    };
}
